import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "@/components/ScrollToTop";
import { AuthProvider } from "@/contexts/AuthContext";
import Index from "./pages/Index";
import HowItWorks from "./pages/HowItWorks";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import AdminEarlyAccess from "./pages/AdminEarlyAccess";
import AdminMaterialRequests from "./pages/AdminMaterialRequests";
import Auth from "./pages/Auth";
import ResetPassword from "./pages/ResetPassword";
import WhatDoesItMean from "./pages/WhatDoesItMean";
import AboutUs from "./pages/AboutUs";
import MaterialRequest from "./pages/MaterialRequest";
import WhatIsDeadstockFabric from "./pages/WhatIsDeadstockFabric";
import Newsletter from "./pages/Newsletter";
import Pricing from "./pages/Pricing";
import EarlyAccess from "./pages/EarlyAccess";
import Press from "./pages/Press";
import Trust from "./pages/Trust";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/admin/early-access" element={<AdminEarlyAccess />} />
            <Route path="/admin/material-requests" element={<AdminMaterialRequests />} />
            <Route path="/what-does-it-mean" element={<WhatDoesItMean />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/request" element={<MaterialRequest />} />
            <Route path="/what-is-deadstock-fabric" element={<WhatIsDeadstockFabric />} />
            <Route path="/newsletter" element={<Newsletter />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/early-access" element={<EarlyAccess />} />
            <Route path="/press" element={<Press />} />
            <Route path="/trust" element={<Trust />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
